import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./layout/layout.routes').then(m => m.LayoutRoutes)
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth-module/auth.routes').then(m => m.AuthRoutes)
    },
    /* Self takers routes */
    {
        path: 'professional-screener',
        loadChildren: () => import('./features/self-takers-module/self-takers.routes').then(m => m.ProfessionalScreenerRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'screener-center',
        loadChildren: () => import('./features/self-takers-module/self-takers.routes').then(m => m.ScreenerCenterRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'health-secretary',
        loadChildren: () => import('./features/self-takers-module/self-takers.routes').then(m => m.HealthSecretaryRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'clinical-laboratory',
        loadChildren: () => import('./features/self-takers-module/self-takers.routes').then(m => m.ClinicalLaboratoryRoutes),
        canActivate: [authGuard]
    },
    /* Treatments routes */
    {
        path: 'insurer',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.insurerRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'dispenser',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.dispenserRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'ips',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.ipsRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'pharmaceutical',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.pharmaceuticalRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'nurse',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.NurseRoutes),
        canActivate: [authGuard]
    },
    {
        path: 'doctor',
        loadChildren: () => import('./features/treatments-module/treatments.routes').then(m => m.DoctorRoutes),
        canActivate: [authGuard]
    }
];
